import type { components } from '@joyful/openapi/types.gen'
import { createEnumSchema } from '@joyful/utils'
import type { EnumValueMeta } from '@joyful/utils'

import type { BadgeProps } from '../Badge'
import { Badge } from '../Badge'

export const ProjectStatusSchema = createEnumSchema<
  components['schemas']['ProjectStatus'],
  EnumValueMeta & { variant: BadgeProps['variant'] }
>([
  { title: 'Active', value: 'ACTIVE', variant: 'success' },
  { title: 'Archived', value: 'ARCHIVED', variant: 'neutral' },
])

export interface ProjectStatusBadgeProps extends Partial<
  Omit<BadgeProps, 'children'>
> {
  status: components['schemas']['ProjectStatus']
}

export function ProjectStatusBadge({
  status,
  ...badgeProps
}: ProjectStatusBadgeProps) {
  const metadata = ProjectStatusSchema.meta(status)
  return (
    <Badge variant={metadata.variant} {...badgeProps}>
      {metadata.title}
    </Badge>
  )
}
